import Immutable from 'immutable'

export const BandwidthPackRecord = Immutable.Record({
  bytes: null,
  direction: 'down',
  id: null,
  one_off_price: null,
  price: null,
}, 'BandwidthPack')

export default function createBandwidthPack(data) {
  return new BandwidthPackRecord(data)
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/BandwidthPack.js